'use strict';

var React = require('react');

var SvgDynamicSourceMajor = function SvgDynamicSourceMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 8c4.418 0 8-1.343 8-3s-3.582-3-8-3-8 1.343-8 3 3.582 3 8 3Zm6.93.5c-1.383.897-3.969 1.5-6.93 1.5s-5.546-.603-6.93-1.5c-.68.441-1.07.954-1.07 1.5 0 1.657 3.582 3 8 3s8-1.343 8-3c0-.546-.39-1.059-1.07-1.5Zm0 5c-1.383.897-3.969 1.5-6.93 1.5s-5.546-.603-6.93-1.5c-.68.441-1.07.954-1.07 1.5 0 1.657 3.582 3 8 3s8-1.343 8-3c0-.546-.39-1.059-1.07-1.5Z"
  }));
};

exports.SvgDynamicSourceMajor = SvgDynamicSourceMajor;
